module.exports = __webpack_public_path__ + "abb4ffd1e847bc37b98929aaba1cbad6.svg";